import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'component-about',
  templateUrl: './about.page.html',
  styleUrls: ['./about.page.css']
})
export class AboutPage implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
